export default "__VITE_ASSET__bmrI$UA7__"